export default ( () => {

    jQuery( document ).ready( function( $ ) {

        $.fn.COTCarousel = function( params ) {
        
            const _this = this

            _this.bindVideoControlButton = function( button, video ) {

                // console.log( "Bind video control button" );

                $( button ).on( 'click', function() {

                    const buttonState = $( this ).attr( 'data-state' );

                    // console.log( "State: \n", buttonState );

                } );

            }

            $( '.carousel-item--video', _this ).each( function ( index, element ) {

                const videoControlWrapper = $( this ).next();

                const videoControlButton = $( '.carousel-control--button', videoControlWrapper );

                // _this.bindVideoControlButton( videoControlButton, this )

            } );

        }

        $( '.cot-blocks--carousel' ).each( function( index, element ) {
        
            $( element ).COTCarousel();

        });
    
    } )

} )()